import React, { Fragment } from "react";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import About from "../../components/about/about";
import PillarsSection from "../../components/PillarsSection/PillarsSection";
import ServiceSection from "../../components/ServiceSection/ServiceSection";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import { useTranslation } from "react-i18next";

const AboutPage = () => {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Navbar />
      <PageTitle pageTitle={t(`aboutUs`)} pagesub={t(`aboutUs`)} />
      <About />
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutPage;
